import { Gear } from 'phosphor-react'
import { ChangeBackgroundPic } from '../ChangeBackgroundPic'

export const BackgroundImage = (props) => {
  const { userData, isGearBackgroundOpen, handleGearBackground } = props
  return (
    <div className=" w-full h-64 z-10">
      {isGearBackgroundOpen && <ChangeBackgroundPic {...props} />}
      <img
        src={
          userData?.backgroundPicture ||
          'https://trustbridge.com/wp-content/uploads/2022/01/Wine-glass-web-banner-2.png'
        }
        alt="Background"
        className="object-cover  w-full h-64"
        loading="eager"
      />

      <div
        className="absolute right-2 z-40 cursor-pointer top-6 lg:top-2 text-branco bg-black/30 backdrop-blur flex justify-center items-center p-2 rounded-2xl"
        onClick={handleGearBackground}
      >
        <Gear size={24} />
      </div>
    </div>
  )
}
